import React from 'react';
import Firebase from 'firebase/app';
import 'firebase/auth';
import 'firebase/database';


const config = {
  // Paste your web app's Firebase configuration here
  apiKey: 'AIzaSyC-KBL5NMiU8c5XrIwXXjQT-QdUEkMMQss',
  authDomain: 'yamm-43ba9.firebaseapp.com',
  databaseURL: 'https://yamm-43ba9-default-rtdb.firebaseio.com',
  projectId: 'yamm-43ba9',
  storageBucket: 'yamm-43ba9.appspot.com',
  messagingSenderId: '36136407061',
  appId: '1:36136407061:web:8580fe083f7a3d57a9fe1c'
};

Firebase.initializeApp(config);

export default Firebase;
export const Auth = Firebase.auth();
export const Database = Firebase.database();
export const UserContext = React.createContext({ user: null });

export const createUniqueKey = () => {
  return Database.ref('/').push().key;
}
